import KeyValuePair from '@/modules/core/support/KeyValuePair'
import User from '@/modules/user/model/User';

/**
 * Voto de moderación
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class ModerationVote {
    public approved = false
    public comment = ''
    public contentType = ''
    public contentId: string | number = 0
    public moderator = new User()
    public createdAt = new Date()
    public updateAt = new Date()

    /**
     * Constructor
     * @param id
     */
    constructor (public readonly id = 0) {}

    /**
     * Comprueba si la entidad es nueva y todavía no ha sido registrada en el servidor
     */
    public get isNew () {
        return !this.id
    }


    /**
     * Restablece el tipo de contenido y su identificador
     *
     * @param type
     * @param id
     */
    public setContent (type: string, id: number | string) {
        this.contentType = type
        this.contentId = id
    }

    /**
     * Convierte un conjunto de datos planos en una entidad
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const vote = new this(data.id)
        vote.approved = data.approved
        vote.comment = data.comment || ''
        vote.contentId = data.content_id
        vote.contentType = data.content_type
        vote.moderator = User.deserialize(data.moderator)
        vote.createdAt = new Date(data.created_at)
        vote.updateAt = new Date(data.updated_at)

        return vote
    }

    /**
     * Convierte la información de una entidad en un objeto plano para ser enviado
     * al servidor
     */
    public serialize () {
        return {
            moderator: this.moderator.id,
            approved: this.approved,
            comment: this.comment,
            content_id: this.contentId,
            content_type: this.contentType,
        }
    }
}
